import React, { useCallback } from 'react';
import { totalDBUData } from 'service/service';
import ComputeHierarchyBase, { FetchServiceParams } from './ComputeHierarchyBase';

const PRESERVE_FILTER_KEY = 'total_dbu_filters';

const TotalDBUTable = () => {
    const serviceFunc = useCallback((params: FetchServiceParams) => {
        return totalDBUData({
            startDate: params.startDate,
            endDate: params.endDate,
            env: params.env,
            sector: params.sector,
            location: params.location,
            page: params.page,
            pageSize: params.pageSize,
            filters: params.filters,
            selectedDateInString: params.apiDateRangeKey
        });
    }, []);

    return (
        <ComputeHierarchyBase
            serviceFunc={serviceFunc}
            pageTitle="Total DBU Details"
            tableTitlePrefix="Total DBUs"
            columnLabel="DBU"
            isCurrency={false}
            preserveFilterKey={PRESERVE_FILTER_KEY}
            detailPath="/databricksADB/total-dbu/details"
            tableType="total-dbu-details-ver"
        />
    );
};

export default TotalDBUTable;